<template lang="pug">
    div
        v-card-title.text-medium.d-flex.flex-row.justify-space-between.align-start.flex-nowrap.mx-2(style="gap: 20px;")
            | {{ customer.first_name }} {{ customer.last_name }} 
            | {{ isCampaignSimulation ? '' : `was ${validationFailed ? 'not' : ''} validated.` }}
            span.text-uppercase.font-weight-bold(
                :class="validationFailed ? 'error' : 'success' | statusClassMatcher"
            ) {{ validationFailed ? 'Failed' : 'Passed' }}

        v-card-text(min-height="500px")
            v-row.mx-2.mb-2.d-flex.flex-column(v-if="validationFailed")
                span {{ customer.error_message }}
                div(style="color: var(--error)")
                    span.text-uppercase.font-weight-bold Failed on: 
                    span {{ failedFlagNames.join(', ') }} 

            v-row.ma-2.mt-4.d-flex.justify-space-around.flex-row.flex-nowrap(v-if="customerFlags.passedFlags.length > 0" style="gap: 20px;")
                    v-col(style="background: linear-gradient(180deg, rgba(76, 175, 80, 0.05) 0%, rgba(76, 175, 80, 0.02) 100%);").flag-list-container
                        .text-uppercase.font-weight-bold.green--text.py-1.mb-4.flag-status.d-flex.flex-row.align-center(style="border-color: var(--success);")
                            | Passed
                            v-icon.ml-2(color="var(--success)" small) mdi-check
                        v-row(v-for="(flag, index) in customerFlags.passedFlags" :key="index")
                            v-col.py-1(cols="12")
                                .text-small.text-black {{ flag.name }}
                    v-col(style="background: linear-gradient(180deg, rgba(244, 67, 54, 0.05) 0%, rgba(244, 67, 54, 0.02) 100%);").flag-list-container
                        .text-uppercase.font-weight-bold.py-1.mb-4.flag-status.d-flex.flex-row.align-center(style="border-color: var(--error); color: var(--error);")
                            | Failed
                            v-icon.ml-2(color="var(--error)" small) mdi-close
                        v-row(v-for="(flag, index) in customerFlags.failedFlags" :key="index")
                            v-col.py-1(cols="12")
                                .text-small.text-black {{ flag.name }}
                    v-col(style="background: linear-gradient(180deg, rgba(128, 128, 128, 0.05) 0%, rgba(128, 128, 128, 0.02) 100%);").flag-list-container
                        .text-uppercase.font-weight-bold.py-1.mb-4.flag-status.d-flex.flex-row.align-center(style="border-color: var(--volie-gray);")
                            | N/A
                        v-row(v-for="(flag, index) in customerFlags.notApplicableFlags" :key="index")
                            v-col.py-1(cols="12")
                                .text-small {{ flag.name }}
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
    data() {
        return {
            failedFlagNames: [],
        }
    },
    computed: {
        validationFailed() {
            return this.customer.status === 'error';
        },
    },
    props: {
        customer: Object,
        customerFlags: Object,
        isCampaignSimulation: Boolean,
    },
    watch: {
        customerFlags: {
            handler(newVal) {
                this.failedFlagNames = newVal.failedFlags.map((flag: any) => flag.name);
            },
            deep: true,
            immediate: true,
        },
    },
})
</script>

<style lang="scss" scoped>
    .flag-list-container {
        border-radius: 5px;
        width: 33%;
        padding: 16px;

        .flag-status {
            border-bottom: 1px solid var(--off-white);
            width: 80%;
        }
    }
</style>